import React from "react";
import { FormattedMessage } from "react-intl";
import SharedText from "../../../shared/SharedText/SharedText";
import "./eye.scss";
const Eye = () => {
  return (
    <div className="mobile-eye">
      <SharedText
        title1={
          <FormattedMessage
            id="mobile-eye-title"
            defaultMessage="Keep an eye on all 
        your campaigns while 
        you're on the go"
          />
        }
        text1={
          <FormattedMessage
            id="mobile-eye-text1"
            defaultMessage="Download AdGate mobile app and track all your transactions in real time. Clear statistics, daily turnover, account balance, invoice and booking overview, quick contact to AdGate team and much more."
          />
        }
      />

      <div className="right">
        <div className="tablet" />
        <div className="mobile" />
      </div>
    </div>
  );
};

export default Eye;
